import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Tooltip } from "@mui/material";
import { BasicProfile } from "protico-sdk";
import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useENS from "../../../hooks/useENS";
import { TaskStateType } from "../../../types/types";

const CommonCard = ({
  handleSetAlert,
  address,
  basicProfile,
}: {
  handleSetAlert: any;
  address: string;
  basicProfile: BasicProfile;
}) => {
  const { t } = useTranslation();
  const { result } = useENS({ address });

  const clickCopy = (source: string, successMsg: string, failMsg: string) => {
    navigator.clipboard.writeText(source).then(
      () => {
        handleSetAlert(successMsg, TaskStateType.SUCCESS);
      },
      () => {
        handleSetAlert(failMsg, TaskStateType.FAIL);
      }
    );
  };

  return (
    <Card>
      <Card.Body
        style={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          paddingLeft: "25px",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Tooltip
          title={t("FlashChat_Profile_Username")}
          disableInteractive
          followCursor
        >
          <Card.Title
            style={{
              fontWeight: "bold",
              fontSize: "22px",
              marginBottom: "10px",
              color:
                basicProfile.name && basicProfile.name !== "" ? "#ddd" : "#888",
              cursor: "pointer",
              textAlign: "left",
              width: "130px",
              wordBreak: "break-all",
            }}
            onClick={() => {
              if (basicProfile.name && basicProfile.name !== "") {
                clickCopy(
                  basicProfile.name as string,
                  t("FlashChat_Profile_Username_Copy_Success"),
                  t("FlashChat_Profile_Username_Copy_Fail")
                );
              }
            }}
          >
            {basicProfile.name && basicProfile.name !== "" ? (
              <>
                {basicProfile.name}
                {result === basicProfile.name && (
                  <VerifiedIcon
                    color="primary"
                    fontSize="small"
                    style={{
                      verticalAlign: "middle",
                      margin: "-5px 0 0 4px",
                    }}
                  />
                )}
              </>
            ) : (
              t("FlashChat_Profile_Username_GUIDE")
            )}
          </Card.Title>
        </Tooltip>
        {address && (
          <Tooltip
            title={t("FlashChat_Profile_Wallet_Address")}
            disableInteractive
            followCursor
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 0",
                marginBottom: "2px",
                fontSize: "12px",
                color: "#aaa",
                cursor: "pointer",
                justifyContent: "flex-start",
              }}
              onClick={() => {
                clickCopy(
                  address,
                  t("FlashChat_Profile_Wallet_Address_Copy_Success"),
                  t("FlashChat_Profile_Wallet_Address_Copy_Fail")
                );
              }}
            >
              <AccountBalanceWalletIcon
                style={{
                  fontSize: "small",
                  marginRight: "5px",
                }}
              />
              <Card.Text
                style={{
                  margin: "0px",
                }}
              >
                {address.slice(0, 10) + "..." + address.slice(-5)}
              </Card.Text>
            </div>
          </Tooltip>
        )}
      </Card.Body>
    </Card>
  );
};
export default CommonCard;
